module.exports = __webpack_public_path__ + "fonts/din-bold-2.05174a2f.ttf";